import HomeLayoutMobile from './HomeLayoutMobile';
import { isMobile } from '../../services/DeviceInformation';
import HomeLayoutDesktop from './HomeLayoutDesktop';

export default function Home() {
    if (isMobile()) {
        return <HomeLayoutMobile />;
    }
    return <HomeLayoutDesktop />;
}
